import apiClient from "./apiClient";

const Url = `/masters`;

export const normalizeMasterItems = (res) => {
  const items = res?.data?.items || res?.items || [];
  return items.map((item) => ({
    value: item.value,
    label: item.label || item.value,
    active: item.active !== false,
    sortOrder: item.sortOrder,
    _id: item._id,
    group: item.group,
    meta: item.meta || {},
  }));
};

export const getMasters = async (props, group, includeInactive = false) => {
  try {
    const params = [];
    if (group) params.push(`group=${encodeURIComponent(group)}`);
    if (includeInactive) params.push("all=1");
    const query = params.length ? `?${params.join("&")}` : "";
    const response = await apiClient.get(`${Url}${query}`);
    return response.data;
  } catch (error) {
    return error;
  }
};

export const createMaster = async (props, body) => {
  try {
    const response = await apiClient.post(Url, body);
    return response.data;
  } catch (error) {
    return error;
  }
};

export const updateMaster = async (props, id, body) => {
  try {
    const response = await apiClient.put(`${Url}/${id}`, body);
    return response.data;
  } catch (error) {
    return error;
  }
};

export const deleteMaster = async (props, id) => {
  try {
    const response = await apiClient.delete(`${Url}/${id}`);
    return response.data;
  } catch (error) {
    return error;
  }
};
